import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { CONSUMER_SITE_BASE_URL } from '../../constants';
import styles from './styles';

const Footer = ({ classes }) => (
  <div className={classes.root}>
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={`${CONSUMER_SITE_BASE_URL}/terms-of-use`}
    >
      Terms of Use
    </a>{' '}
    |{' '}
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={`${CONSUMER_SITE_BASE_URL}/privacy-policy`}
    >
      Privacy Policy
    </a>
  </div>
);

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer);
